import React, {useContext} from 'react';

import {Carousel} from "react-bootstrap";

import image1 from '../images/portfolio/startPhotos/1.webp';
import image2 from '../images/portfolio/startPhotos/2.webp';
import image3 from '../images/portfolio/startPhotos/3.webp';
import image4 from '../images/portfolio/startPhotos/4.webp';
import image5 from '../images/portfolio/startPhotos/5.webp';
import image6 from '../images/portfolio/startPhotos/6.webp';
import image7 from '../images/portfolio/startPhotos/7.webp';
import bathroom1 from '../images/portfolio/bathroom/1.webp';
import bathroom2 from '../images/portfolio/bathroom/2.webp';
import bathroom3 from '../images/portfolio/bathroom/3.webp';
import bathroom4 from '../images/portfolio/bathroom/4.webp';
import bathroom5 from '../images/portfolio/bathroom/5.webp';
import bathroom6 from '../images/portfolio/bathroom/6.webp';
import bathroom7 from '../images/portfolio/bathroom/7.webp';
import bathroom8 from '../images/portfolio/bathroom/8.webp';
import bathroom9 from '../images/portfolio/bathroom/9.webp';
import bathroom10 from '../images/portfolio/bathroom/10.webp';
import showerpan1 from '../images/portfolio/showerpan/1.webp';
import showerpan2 from '../images/portfolio/showerpan/2.webp';
import showerpan3 from '../images/portfolio/showerpan/3.webp';
import showerpan4 from '../images/portfolio/showerpan/4.webp';
import showerpan5 from '../images/portfolio/showerpan/5.webp';
import showerpan6 from '../images/portfolio/showerpan/6.webp';
import showerpan7 from '../images/portfolio/showerpan/7.webp';
import showerpan8 from '../images/portfolio/showerpan/8.webp';
import showerpan9 from '../images/portfolio/showerpan/9.webp';
import showerpan10 from '../images/portfolio/showerpan/10.webp';
import showerpan11 from '../images/portfolio/showerpan/11.webp';
import showerpan12 from '../images/portfolio/showerpan/12.webp';
import showerpan13 from '../images/portfolio/showerpan/13.webp';
import showerpan14 from '../images/portfolio/showerpan/14.webp';
import showerpan15 from '../images/portfolio/showerpan/15.webp';
import showerpan16 from '../images/portfolio/showerpan/16.webp';
import imageBacksplash1 from '../images/portfolio/backsplash/1.webp';
import imageBacksplash2 from '../images/portfolio/backsplash/2.webp';
import imageBacksplash3 from '../images/portfolio/backsplash/3.webp';
import imageWallpaper1 from '../images/portfolio/wallpaper/1.webp';
import imageWallpaper2 from '../images/portfolio/wallpaper/2.webp';
import imageWallpaper3 from '../images/portfolio/wallpaper/3.webp';
import imageWallpaper4 from '../images/portfolio/wallpaper/4.webp';
import imageWallpaper5 from '../images/portfolio/wallpaper/5.webp';
import imageWallpaper6 from '../images/portfolio/wallpaper/6.webp';
import imageWallpaper7 from '../images/portfolio/wallpaper/7.webp';
import imageWallpaper8 from '../images/portfolio/wallpaper/8.webp';
import imageWallpaper9 from '../images/portfolio/wallpaper/9.webp';
import imageBefore11_1 from '../images/portfolio/before_after/project11/1.webp';
import imageBefore11_2 from '../images/portfolio/before_after/project11/2.webp';
import imageBefore11_3 from '../images/portfolio/before_after/project11/3.webp';
import imageBefore11_4 from '../images/portfolio/before_after/project11/4.webp';
import imageBefore11_5 from '../images/portfolio/before_after/project11/5.webp';
import imageBefore11_6 from '../images/portfolio/before_after/project11/6.webp';
import imageBefore11_7 from '../images/portfolio/before_after/project11/7.webp';
import imageBefore11_8 from '../images/portfolio/before_after/project11/8.webp';
import imageBefore11_9 from '../images/portfolio/before_after/project11/9.webp';
import imageBefore12_1 from '../images/portfolio/before_after/project12/1.webp';
import imageBefore12_2 from '../images/portfolio/before_after/project12/2.webp';
import imageProject1_1 from '../images/portfolio/projects/project1/1.webp';
import imageProject1_2 from '../images/portfolio/projects/project1/2.webp';
import imageProject1_3 from '../images/portfolio/projects/project1/3.webp';
import imageProject1_4 from '../images/portfolio/projects/project1/4.webp';
import imageProject1_5 from '../images/portfolio/projects/project1/5.webp';
import imageProject2_1 from '../images/portfolio/projects/project2/1.webp';
import imageProject2_2 from '../images/portfolio/projects/project2/2.webp';
import imageProject2_3 from '../images/portfolio/projects/project2/3.webp';
import imageProject2_4 from '../images/portfolio/projects/project2/4.webp';
import imageProject2_5 from '../images/portfolio/projects/project2/5.webp';
import imageProject2_6 from '../images/portfolio/projects/project2/6.webp';
import imageProject2_7 from '../images/portfolio/projects/project2/7.webp';
import imageProject2_8 from '../images/portfolio/projects/project2/8.webp';
import imageProject2_9 from '../images/portfolio/projects/project2/9.webp';
import imageProject2_10 from '../images/portfolio/projects/project2/10.webp';
import imageProject2_11 from '../images/portfolio/projects/project2/11.webp';
import imageProject2_12 from '../images/portfolio/projects/project2/12.webp';
import imageProject2_13 from '../images/portfolio/projects/project2/13.webp';
import project3_1 from '../images/portfolio/projects/project3/1.webp';
import project3_2 from '../images/portfolio/projects/project3/2.webp';
import project4_1 from '../images/portfolio/projects/project4/1.webp';
import project4_2 from '../images/portfolio/projects/project4/2.webp';
import project4_3 from '../images/portfolio/projects/project4/3.webp';
import project4_4 from '../images/portfolio/projects/project4/4.webp';
import project5_1 from '../images/portfolio/projects/project5/1.webp';
import project5_2 from '../images/portfolio/projects/project5/2.webp';
import project6_1 from '../images/portfolio/projects/project6/1.webp';
import project6_2 from '../images/portfolio/projects/project6/2.webp';
import project7_1 from '../images/portfolio/projects/project7/1.webp';
import project7_2 from '../images/portfolio/projects/project7/2.webp';
import project8_1 from '../images/portfolio/projects/project8/1.webp';
import project8_2 from '../images/portfolio/projects/project8/2.webp';
import imageBefore1_1 from '../images/portfolio/before_after/project1/1.webp';
import imageBefore1_2 from '../images/portfolio/before_after/project1/2.webp';
import imageBefore1_3 from '../images/portfolio/before_after/project1/3.webp';
import imageBefore1_4 from '../images/portfolio/before_after/project1/4.webp';
import imageBefore1_5 from '../images/portfolio/before_after/project1/5.webp';
import imageBefore1_6 from '../images/portfolio/before_after/project1/6.webp';
import imageBefore1_7 from '../images/portfolio/before_after/project1/7.webp';
import imageBefore2_1 from '../images/portfolio/before_after/project2/1.webp';
import imageBefore2_2 from '../images/portfolio/before_after/project2/2.webp';
import imageBefore2_3 from '../images/portfolio/before_after/project2/3.webp';
import imageBefore2_4 from '../images/portfolio/before_after/project2/4.webp';
import imageBefore2_5 from '../images/portfolio/before_after/project2/5.webp';
import imageBefore3_1 from '../images/portfolio/before_after/project3/1.webp';
import imageBefore3_2 from '../images/portfolio/before_after/project3/2.webp';
import imageBefore3_3 from '../images/portfolio/before_after/project3/3.webp';
import imageBefore3_4 from '../images/portfolio/before_after/project3/4.webp';
import imageBefore3_5 from '../images/portfolio/before_after/project3/5.webp';
import imageBefore3_6 from '../images/portfolio/before_after/project3/6.webp';
import imageBefore3_7 from '../images/portfolio/before_after/project3/7.webp';
import imageBefore3_8 from '../images/portfolio/before_after/project3/8.webp';
import imageBefore3_9 from '../images/portfolio/before_after/project3/9.webp';
import imageBefore3_10 from '../images/portfolio/before_after/project3/10.webp';
import imageBefore4_1 from '../images/portfolio/before_after/project4/1.webp';
import imageBefore4_2 from '../images/portfolio/before_after/project4/2.webp';
import imageBefore4_3 from '../images/portfolio/before_after/project4/3.webp';
import imageBefore4_4 from '../images/portfolio/before_after/project4/4.webp';
import imageBefore4_5 from '../images/portfolio/before_after/project4/5.webp';
import imageBefore4_6 from '../images/portfolio/before_after/project4/6.webp';
import imageBefore4_7 from '../images/portfolio/before_after/project4/7.webp';
import imageBefore4_8 from '../images/portfolio/before_after/project4/8.webp';
import imageBefore4_9 from '../images/portfolio/before_after/project4/9.webp';
import imageBefore5_1 from '../images/portfolio/before_after/project5/1.webp';
import imageBefore5_2 from '../images/portfolio/before_after/project5/2.webp';
import imageBefore5_3 from '../images/portfolio/before_after/project5/3.webp';
import imageBefore5_4 from '../images/portfolio/before_after/project5/4.webp';
import imageBefore5_5 from '../images/portfolio/before_after/project5/5.webp';
import imageBefore5_6 from '../images/portfolio/before_after/project5/6.webp';
import imageBefore5_7 from '../images/portfolio/before_after/project5/7.webp';
import imageBefore5_8 from '../images/portfolio/before_after/project5/8.webp';
import imageBefore5_9 from '../images/portfolio/before_after/project5/9.webp';
import imageBefore5_10 from '../images/portfolio/before_after/project5/10.webp';
import imageBefore5_11 from '../images/portfolio/before_after/project5/11.webp';
import imageBefore5_12 from '../images/portfolio/before_after/project5/12.webp';
import imageBefore5_13 from '../images/portfolio/before_after/project5/13.webp';
import imageBefore6_1 from '../images/portfolio/before_after/project6/1.webp';
import imageBefore6_2 from '../images/portfolio/before_after/project6/2.webp';
import imageBefore6_3 from '../images/portfolio/before_after/project6/3.webp';
import imageBefore6_4 from '../images/portfolio/before_after/project6/4.webp';
import imageBefore6_5 from '../images/portfolio/before_after/project6/5.webp';
import imageBefore6_6 from '../images/portfolio/before_after/project6/6.webp';
import imageBefore6_7 from '../images/portfolio/before_after/project6/7.webp';
import imageBefore6_8 from '../images/portfolio/before_after/project6/8.webp';
import imageBefore6_9 from '../images/portfolio/before_after/project6/9.webp';
import imageBefore6_10 from '../images/portfolio/before_after/project6/10.webp';
import imageBefore6_11 from '../images/portfolio/before_after/project6/11.webp';
import imageBefore6_12 from '../images/portfolio/before_after/project6/12.webp';
import imageBefore6_13 from '../images/portfolio/before_after/project6/13.webp';
import imageBefore6_14 from '../images/portfolio/before_after/project6/14.webp';
import imageBefore6_15 from '../images/portfolio/before_after/project6/15.webp';
import imageBefore7_1 from '../images/portfolio/before_after/project7/1.webp';
import imageBefore7_2 from '../images/portfolio/before_after/project7/2.webp';
import imageBefore7_3 from '../images/portfolio/before_after/project7/3.webp';
import imageBefore7_4 from '../images/portfolio/before_after/project7/4.webp';
import imageBefore7_5 from '../images/portfolio/before_after/project7/5.webp';
import imageBefore7_6 from '../images/portfolio/before_after/project7/6.webp';
import imageBefore7_7 from '../images/portfolio/before_after/project7/7.webp';
import imageBefore7_8 from '../images/portfolio/before_after/project7/8.webp';
import imageBefore7_9 from '../images/portfolio/before_after/project7/9.webp';

import imageBefore8_1 from '../images/portfolio/before_after/project8/1.webp';
import imageBefore8_2 from '../images/portfolio/before_after/project8/2.webp';
import imageBefore8_3 from '../images/portfolio/before_after/project8/3.webp';
import imageBefore8_4 from '../images/portfolio/before_after/project8/4.webp';
import imageBefore8_5 from '../images/portfolio/before_after/project8/5.webp';
import imageBefore8_6 from '../images/portfolio/before_after/project8/6.webp';
import imageBefore8_7 from '../images/portfolio/before_after/project8/7.webp';
import imageBefore8_8 from '../images/portfolio/before_after/project8/8.webp';
import imageBefore8_9 from '../images/portfolio/before_after/project8/9.webp';
import imageBefore8_10 from '../images/portfolio/before_after/project8/10.webp';
import imageBefore8_11 from '../images/portfolio/before_after/project8/11.webp';
import imageBefore8_12 from '../images/portfolio/before_after/project8/12.webp';
import imageBefore8_13 from '../images/portfolio/before_after/project8/13.webp';
import imageBefore8_14 from '../images/portfolio/before_after/project8/14.webp';
import imageBefore8_15 from '../images/portfolio/before_after/project8/15.webp';
import imageBefore8_16 from '../images/portfolio/before_after/project8/16.webp';
import imageBefore8_17 from '../images/portfolio/before_after/project8/17.webp';
import imageBefore8_18 from '../images/portfolio/before_after/project8/18.webp';
import imageBefore8_19 from '../images/portfolio/before_after/project8/19.webp';
import imageBefore8_20 from '../images/portfolio/before_after/project8/20.webp';
import imageBefore8_21 from '../images/portfolio/before_after/project8/21.webp';
import imageBefore8_22 from '../images/portfolio/before_after/project8/22.webp';
import imageBefore8_23 from '../images/portfolio/before_after/project8/23.webp';
import imageBefore8_24 from '../images/portfolio/before_after/project8/24.webp';
import imageBefore8_25 from '../images/portfolio/before_after/project8/25.webp';
import laminate1 from '../images/portfolio/laminate/1.webp';
import laminate2 from '../images/portfolio/laminate/2.webp';
import painting1 from '../images/portfolio/painting/1.webp';
import painting2 from '../images/portfolio/painting/2.webp';
import painting3 from '../images/portfolio/painting/3.webp';
import imageBefore9_1 from '../images/portfolio/before_after/project9/1.webp';
import imageBefore9_2 from '../images/portfolio/before_after/project9/2.webp';
import imageBefore9_3 from '../images/portfolio/before_after/project9/3.webp';
import imageBefore9_4 from '../images/portfolio/before_after/project9/4.webp';
import imageBefore9_5 from '../images/portfolio/before_after/project9/5.webp';

import imageBefore10_1 from '../images/portfolio/before_after/project10/1.webp';
import imageBefore10_2 from '../images/portfolio/before_after/project10/2.webp';
import imageBefore10_3 from '../images/portfolio/before_after/project10/3.webp';
import imageBefore10_4 from '../images/portfolio/before_after/project10/4.webp';
import imageBefore10_5 from '../images/portfolio/before_after/project10/5.webp';
import imageBefore10_6 from '../images/portfolio/before_after/project10/6.webp';
import imageBefore10_7 from '../images/portfolio/before_after/project10/7.webp';
import imageBefore10_8 from '../images/portfolio/before_after/project10/8.webp';
import imageBefore10_9 from '../images/portfolio/before_after/project10/9.webp';
import imageBefore10_10 from '../images/portfolio/before_after/project10/10.webp';
import imageBefore10_11 from '../images/portfolio/before_after/project10/11.webp';
import imageBefore10_12 from '../images/portfolio/before_after/project10/12.webp';
import imageBefore10_13 from '../images/portfolio/before_after/project10/13.webp';
import imageBefore10_14 from '../images/portfolio/before_after/project10/14.webp';
import imageBefore10_15 from '../images/portfolio/before_after/project10/15.webp';
import imageBefore10_16 from '../images/portfolio/before_after/project10/16.webp';
import imageBefore10_17 from '../images/portfolio/before_after/project10/17.webp';
import imageBefore10_18 from '../images/portfolio/before_after/project10/18.webp';
import stairs1 from '../images/portfolio/stairs/1.webp';
import stairs2 from '../images/portfolio/stairs/2.webp';
import before_13_1 from '../images/portfolio/before_after/project13/1.webp';
import before_13_2 from '../images/portfolio/before_after/project13/2.webp';
import before_13_3 from '../images/portfolio/before_after/project13/3.webp';
import before_13_4 from '../images/portfolio/before_after/project13/4.webp';
import before_13_5 from '../images/portfolio/before_after/project13/5.webp';

import classes from "../styles/pages/portfolioPage.module.scss";
import {LanguageContext} from "../App";

function PortfolioSlider() {

    const languageContext = useContext(LanguageContext);

    return(
        <>
            <Carousel variant="dark">
                <Carousel.Item interval={6000}>
                    <img src={image1} className={classes.carouselImages}/>
                </Carousel.Item>
                <Carousel.Item interval={6000}>
                    <img src={image2} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={6000}>
                    <img src={image3} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={6000}>
                    <img src={image4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={10000}>
                    <img src={image5} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={6000}>
                    <img src={image6} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={6000}>
                    <img src={image7} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
            </Carousel>

            <h2>{languageContext.portfolioPage.bathroom}</h2>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={bathroom1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={bathroom2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={bathroom3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={bathroom4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={bathroom5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={bathroom6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={bathroom7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={bathroom8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={bathroom9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={bathroom10} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <h2>{languageContext.portfolioPage.showerPan}</h2>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={showerpan1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan10} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan11} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan12} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan13} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan14} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan15} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={showerpan16} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <h2>{languageContext.portfolioPage.backsplash}</h2>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBacksplash1} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBacksplash2} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBacksplash3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <h2>{languageContext.portfolioPage.wallpaper}</h2>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageWallpaper1} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageWallpaper2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageWallpaper3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageWallpaper4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageWallpaper5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageWallpaper6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageWallpaper7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageWallpaper8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageWallpaper9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>

            <h2>{languageContext.portfolioPage.stairs}</h2>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={stairs1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={stairs2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>

            <h2>{languageContext.portfolioPage.laminate}</h2>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={laminate1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={laminate2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>

            <h2>{languageContext.portfolioPage.painting}</h2>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={painting1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={painting2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={painting3} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
            </Carousel>

            <h2>{languageContext.portfolioPage.projects}</h2>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={project8_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={project8_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={project3_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={project3_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={project4_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={project4_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={project4_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={project4_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_10} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_11} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_12} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject2_13} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={project5_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={project5_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={project6_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={project6_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={project7_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={project7_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageProject1_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject1_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject1_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject1_4} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageProject1_5} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
            </Carousel>

            <h2>{languageContext.portfolioPage.beforeAfter}</h2>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore12_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore12_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={before_13_1} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={before_13_2} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={before_13_3} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={before_13_4} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={before_13_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore1_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore1_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore1_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore1_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore1_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore1_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore1_7} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore3_10} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore4_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore4_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore4_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore4_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore4_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore4_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore4_7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore4_8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore4_9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_10} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_11} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_12} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore5_13} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_10} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_11} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_12} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_13} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_14} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore6_15} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore7_1} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore7_2} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore7_3} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore7_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore7_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore7_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore7_7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore7_8} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore7_9} className={classes.carouselImages} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_10} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_11} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_12} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_13} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_14} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_15} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_16} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_17} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_18} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_19} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_20} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_21} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_22} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_23} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_24} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore8_25} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore11_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore11_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore11_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore11_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore11_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore11_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore11_7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore11_8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore11_9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore9_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore9_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore9_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore9_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore9_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_6} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_7} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_8} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_9} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_10} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_11} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_12} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_13} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_14} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_15} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_16} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_17} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore10_18} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
            <br/>
            <Carousel variant="dark">
                <Carousel.Item interval={40000}>
                    <img src={imageBefore2_1} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore2_2} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore2_3} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore2_4} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
                <Carousel.Item interval={40000}>
                    <img src={imageBefore2_5} className={classes.carouselImagesVertical} loading="lazy"/>
                </Carousel.Item>
            </Carousel>
        </>
    );
}

export default PortfolioSlider;